import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './SetGuardian.css';
import { fireAudit } from '../utils/auditClient';

const NewPlayerGuadian = () => {
  const location = useLocation();
  const { academyId, userId } = location.state || {};

  const [playername, setPlayername] = useState({
    name: '',
    mobile: '',
  });
  const [guardians, setGuardians] = useState([
    { parentNumber: '', name: '', relation: '' },
    { parentNumber: '', name: '', relation: '' },
  ]);
  const baselineRef = useRef(null);

  const token = localStorage.getItem('auth-token');
  useEffect(() => {
    const fetchGuardianData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_PLAYER_GUARDIAN}?academy_id=${academyId}&user_id=${userId}&type=PLAYER`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        if (data.success && data.data.userSelected) {
          setPlayername({
            name: data.data.userSelected?.name || 'N/A',
            mobile: data.data.userSelected?.mobile_number || 'N/A',
          });
        }
      } catch (error) {}
    };

    if (academyId && userId) {
      fetchGuardianData();
    }
  }, [academyId, userId]);

  useEffect(() => {
    baselineRef.current = {
      academyId,
      userId,
      player: { ...playername },
      guardians: guardians.map(g => ({ ...g })),
    };
  }, [playername?.name, playername?.mobile, academyId, userId]);

  const handleSubmit = () => {
    alert('Form Submitted');
    const newPayload = {
      academyId,
      userId,
      player: { ...playername },
      guardians: guardians.map(g => ({ ...g })),
    };
    const oldPayload = baselineRef.current || {};
    const affected_id = `${userId}`;
    fireAudit({
      entity: 'player_guardian',
      affected_id,
      affected_user:userId,
      action: 'create',
      section: 'Coaching',
      subSection: 'SetPlayer',
      businessApi: process.env.REACT_APP_API_PLAYER_GUARDIAN,
      businessMethod: 'POST',
      oldPayload,
      newPayload,
      extra: { page: 'SetGuardian' },
    });
    baselineRef.current = newPayload;
  };

  return (
    <div className="enrollment-container">
      <div className="sg-guardian-info">
        <h3>Selected Player's Information</h3>
        <label>Name:</label>
        <input type="text" value={playername.name} disabled className="sg-input" />

        <label>Mobile:</label>
        <input
          type="text"
          value={playername.mobile.replace(/^\+91/, '')}
          disabled
          className="sg-input"
        />
      </div>

      <div className="sg-guardian-selection">
        <div className="sg-guardian-entry-table">
          <h3>Enter Guardian Information</h3>
          <table>
            <thead>
              <tr>
                <th>Parent Number</th>
                <th>Name</th>
                <th>Relation</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><input type="text" placeholder="Enter parent number" className="sg-input" value={guardians[0].parentNumber} onChange={(e) => setGuardians(prev => { const n=[...prev]; n[0].parentNumber = e.target.value.replace(/\D/g,'').slice(0,10); return n; })} /></td>
                <td><input type="text" placeholder="Enter name" className="sg-input" value={guardians[0].name} onChange={(e) => setGuardians(prev => { const n=[...prev]; n[0].name = e.target.value; return n; })} /></td>
                <td><input type="text" placeholder="Enter relation" className="sg-input" value={guardians[0].relation} onChange={(e) => setGuardians(prev => { const n=[...prev]; n[0].relation = e.target.value; return n; })} /></td>
              </tr>
              <tr>
                <td><input type="text" placeholder="Enter parent number" className="sg-input" value={guardians[1].parentNumber} onChange={(e) => setGuardians(prev => { const n=[...prev]; n[1].parentNumber = e.target.value.replace(/\D/g,'').slice(0,10); return n; })} /></td>
                <td><input type="text" placeholder="Enter name" className="sg-input" value={guardians[1].name} onChange={(e) => setGuardians(prev => { const n=[...prev]; n[1].name = e.target.value; return n; })} /></td>
                <td><input type="text" placeholder="Enter relation" className="sg-input" value={guardians[1].relation} onChange={(e) => setGuardians(prev => { const n=[...prev]; n[1].relation = e.target.value; return n; })} /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="sg-submit-btn-container">
        <button className="submit-button" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default NewPlayerGuadian;
